/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Actions/view.blocks to change it.
import OpenInNewTabAction from './OpenInNewTabAction/index'
import React from 'react'
import SendDocument from './SendDocument/index'
import Signature from './Signature/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Actions({
  children,
  viewPath = "/DesignSystem/PreviewDocument/Content/Content/PdfFile/Actions"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Actions.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<OpenInNewTabAction
  viewPath={`${viewPath}/OpenInNewTabAction`}
/>
<SendDocument
  viewPath={`${viewPath}/SendDocument`}
/>
<Signature
  viewPath={`${viewPath}/Signature`}
/>
</div>
{children}
</React.Fragment>)
}